// src/app/app-routing.module.ts
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './components/landing/landing.component';
import { LoginComponent } from './components/login/login.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { MainLayoutComponent } from './components/layout/main-layout.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AgendaComponent } from './components/agenda/agenda.component';
import { PatientsComponent } from './components/patients/patients.component';
import { ProfessionalsComponent } from './components/professionals/professionals.component';
import { MedicalRecordsComponent } from './components/medical-records/medical-records.component';
import { AuthGuard } from './guards/auth.guard';

// Financial Module Components
import { SuppliersComponent } from './components/suppliers/suppliers.component';
import { AccountCategoriesComponent } from './components/account-categories/account-categories.component';
import { CostCentersComponent } from './components/cost-centers/cost-centers.component';
import { BankAccountsComponent } from './components/bank-accounts/bank-accounts.component';
import { HealthInsurancesComponent } from './components/health-insurances/health-insurances.component';
import { AccountsReceivableComponent } from './components/accounts-receivable/accounts-receivable.component';
import { AccountsPayableComponent } from './components/accounts-payable/accounts-payable.component';

const routes: Routes = [
  { path: '', component: LandingComponent },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dashboard',       component: DashboardComponent },
      { path: 'professionals',   component: ProfessionalsComponent },
      { path: 'agenda',          component: AgendaComponent },
      { path: 'patients',        component: PatientsComponent },
      { path: 'medical-records', component: MedicalRecordsComponent },
      // Financial Module Routes
      { path: 'suppliers',           component: SuppliersComponent },
      { path: 'account-categories',  component: AccountCategoriesComponent },
      { path: 'cost-centers',        component: CostCentersComponent },
      { path: 'bank-accounts',       component: BankAccountsComponent },
      { path: 'health-insurances',   component: HealthInsurancesComponent },
      { path: 'accounts-receivable', component: AccountsReceivableComponent },
      { path: 'accounts-payable',    component: AccountsPayableComponent },
    ]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
